import React, { useState, useEffect } from 'react'
import { Cascader, Form, Input, Button,Row, message } from "antd";
import RoleApi from '@api/role'
import AddModal from '@components/Modal'
import InspectionApi from '@api/inspectionnew'
import DepartmentApi from '@api/department'

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 17 },
};

export default ({ title, visible, formData = null, cancel }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState()
  const [deptList, setDeptList] = useState([])
  useEffect(() => {
    form.setFieldsValue(formData)
    DepartmentApi.getDeptForTree({}).then(res => {
      if (res.status === '0') {
        setDeptList(res.data)
      }
    })
    return () => { }
  }, [])
  // 提交
  const submit = () => {
    form.validateFields().then(values => {
      if (!values) return
      setLoading(true)

      let ary = []
      values.deptIds.forEach(item => {
        ary.push(item[item.length-1])
      })
      let params = {
        defectLevelName: values.defectLevelName,
        recOperate: values.recOperate,
        remark: values.remark,
        deptIds: ary
      }
      if (formData && formData.id) {
        InspectionApi.defectLevelUpdate({ ...params, id: formData.id }).then(res => {
          if (res.status == 0) {
            message.success('修改成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch(err => {
          setLoading(false)
        })
      } else {
        InspectionApi.defectLevelAdd(params).then(res => {
          if (res.status == 0) {
            message.success('添加成功')
            handelCancel(true)
          }
          setLoading(false)
        }).catch((err) => {
          setLoading(false)
        })
      }
    })
  }
  // 取消
  const handelCancel = (bool = false) => {
    form.resetFields();
    cancel(bool);
  }
  return (
    <AddModal title={title} footer={[
      <Row key={'btn'} span={24}>
        <Button key={1} onClick={handelCancel} className='abuttons'>
          <i className='iconfont iconfanhui'>
          </i>&nbsp;&nbsp;取消
        </Button>
        <Button key={2} loading={loading} onClick={submit} className='abuttons' type="primary">
          <i className='iconfont iconbaocun'>
          </i>&nbsp;&nbsp;保存
        </Button>
      </Row>]
    } visible={visible} width={600} okText={'确定'} onCancel={handelCancel} onSubmit={() => submit()}>
      <div className='userModal'>
        <Form preserve={false}
          {...layout}
          layout="horizontal"
          form={form}
          style={{ marginTop: '20px' }}
        >
          <Form.Item
            label='缺陷等级名称'
            name="defectLevelName"
            rules={[{ required: true, message: '请输入缺陷等级名称' }]}
          >
            <Input row={4} placeholder={'请输入缺陷等级名称'} />
          </Form.Item>
          <Form.Item
            label='建议操作'
            name="recOperate"
            rules={[{ required: true, message: '请输入建议操作' }]}
          >
            <Input row={4} placeholder={'请输入建议操作'} />
          </Form.Item>
          <Form.Item label='缺陷等级说明' name="remark" rules={[{ required: true, message: '请输入缺陷等级说明!' }]}>
            <Input.TextArea row={4} placeholder={'请输入缺陷等级说明'} />
          </Form.Item>
          <Form.Item
              label='通知部门'
              name="deptIds"
              rules={[{ required: true, message: '请选择通知角色' }]}
            >
              <Cascader
                multiple
                fieldNames={{
                  label: 'name',
                  value: 'id',
                  children: 'children',
                }}
                options={deptList}
                showCheckedStrategy={Cascader.SHOW_CHILD}
                placeholder="请选择" />
            </Form.Item>
        </Form>
      </div>
    </AddModal>
  )

}
